import { render } from "./BookVariantSummaries.vue?vue&type=template&id=59ef812e&scoped=true"
import script from "./BookVariantSummaries.vue?vue&type=script&lang=js"
export * from "./BookVariantSummaries.vue?vue&type=script&lang=js"

import "./BookVariantSummaries.vue?vue&type=style&index=0&id=59ef812e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ef812e"],['__file',"src/views/Products/BookVariantSummaries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59ef812e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59ef812e', __exports__)) {
    api.reload('59ef812e', __exports__)
  }
  
  module.hot.accept("./BookVariantSummaries.vue?vue&type=template&id=59ef812e&scoped=true", () => {
    api.rerender('59ef812e', render)
  })

}


export default __exports__